import {
  Component,
  ContentChildren,
  ElementRef,
  HostBinding,
  Input,
  QueryList
} from '@angular/core';
import { FormControlName } from '@angular/forms';
import { ErrorMessage } from '../../Models/ErrorMessage';
import { ErrorMessageService } from '../../Services/error-message.service';
export class FormGroupComponent {
  
  FormControlNames: QueryList<FormControlName>;

   customErrorMessages: ErrorMessage[] = [];

   validationDisabled: boolean = false;
/**
 * @return {?}
 */
get hasErrors() {
    return (
      this.FormControlNames.some(c => !c.valid && c.dirty && c.touched) &&
      !this.validationDisabled
    );
  }
/**
 * @return {?}
 */
get hasSuccess() {
    return (
      !this.FormControlNames.some(c => !c.valid) &&
      this.FormControlNames.some(c => c.dirty && c.touched) &&
      !this.validationDisabled
    );
  }
/**
 * @param {?} elRef
 * @param {?} errorMessageService
 */
constructor(
private elRef: ElementRef,
private errorMessageService: ErrorMessageService
  ) {}
/**
 * @return {?}
 */
get label() {
    const /** @type {?} */ label = this.elRef.nativeElement.querySelector("label");
    return label && label.textContent ? label.textContent.trim() : "This field";
  }
/**
 * @return {?}
 */
get isDirtyAndTouched() {
    return this.FormControlNames.some(c => c.dirty && c.touched);
  }
/**
 * @return {?}
 */
get errorMessages(): ErrorMessage[] {
    return [
      ...this.customErrorMessages,
      ...this.errorMessageService.errorMessages
    ];
  }
/**
 * @return {?}
 */
get messages(): string[] {
    const /** @type {?} */ messages = [];
    if (!this.isDirtyAndTouched || this.validationDisabled) return messages;
    this.FormControlNames.filter(c => !c.valid).forEach(control => {
      Object.keys(control.errors).forEach(key => {
        const /** @type {?} */ error = this.errorMessages.find(error => error.error === key);
        if (!error) return;
        messages.push(error.format(this.label, control.errors[key]));
      });
    });
    return messages;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: ".form-group",
  template: `
    <ng-content></ng-content>
    <span class="help-block" *ngFor="let message of messages">{{message}}</span>
  `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: ErrorMessageService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'FormControlNames': [{ type: ContentChildren, args: [FormControlName, ] },],
'customErrorMessages': [{ type: Input },],
'validationDisabled': [{ type: Input },],
'hasErrors': [{ type: HostBinding, args: ["class.has-error", ] },],
'hasSuccess': [{ type: HostBinding, args: ["class.has-success", ] },],
};
}

function FormGroupComponent_tsickle_Closure_declarations() {
/** @type {?} */
FormGroupComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormGroupComponent.ctorParameters;
/** @type {?} */
FormGroupComponent.propDecorators;
/** @type {?} */
FormGroupComponent.prototype.FormControlNames;
/** @type {?} */
FormGroupComponent.prototype.customErrorMessages;
/** @type {?} */
FormGroupComponent.prototype.validationDisabled;
/** @type {?} */
FormGroupComponent.prototype.elRef;
/** @type {?} */
FormGroupComponent.prototype.errorMessageService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ~/ng-bootstrap-form-validation/ng-bootstrap-form-validation/src/lib/Components/form-group-component/form-group-component.ts